/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const TeamManagement = lazyLoad(
  () => import('./index'),
  module => {
    return module.TeamManagement;
  },
);
